import type { NoteContext, UpdateNoteCommand } from "@masta/generated-model";
import type { NoteViewItem } from "./noteViewModel";

export function noteContext(kind: string, objectId: string, fields: Partial<NoteContext> = {}): NoteContext {
  const context = { kind, objectId, scenarioId: null, revisionNumber: null, orderLineId: null, stepId: null, stepResourceSpecId: null, ...fields };
  if (context.orderLineId === "00000000-0000-0000-0000-000000000000") context.orderLineId = null;
  return context;
}

export function noteUpdatePayload(note: NoteViewItem, context: NoteContext | null): UpdateNoteCommand {
  return {
    id: note.id,
    revisionNumber: note.revisionNumber,
    expectedEditVersion: note.editVersion ?? 0,
    context,
    scenarioId: context?.scenarioId ?? null,
    text: note.text,
    name: note.name,
    color: note.color
  };
}

// A transport error or server failure does not establish whether the create committed.
export function isNoteSaveOutcomeUnknown(error: unknown): boolean {
  const status = (error as { status?: number; response?: { status?: number } } | null)?.status ?? (error as { response?: { status?: number } } | null)?.response?.status;
  return status == null || status >= 500;
}

// A successful update advances ExpectedEditVersion by exactly one on the server.
// Preserve occurrence-specific fields (step, order line, chips) and fields not sent by this command.
export function noteAfterUpdate<T extends { editVersion?: number; text: string; name: string; color: string }>(note: T, command: UpdateNoteCommand): T {
  return {
    ...note,
    text: command.text ?? note.text,
    name: command.name ?? note.name,
    color: command.color ?? note.color,
    editVersion: (command.expectedEditVersion ?? 0) + 1
  };
}
